import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

// Import's Service:
import {
  ServicioSomaService,
  SomaServiceEntity,
  ObjetoSomaEntity
} from "../../services/servicio-soma.service";
import { DataPermisosService } from "src/app/services/utils/data-permisos.service";
import { GenerarTxtSomaService } from "src/app/services/utils/generar-txt-soma.service";

@Component({
  selector: "app-reporte-soma",
  templateUrl: "./reporte-soma.component.html",
  styleUrls: ["./reporte-soma.component.css"]
})
export class ReporteSomaComponent implements OnInit {
  private objetoSoma: SomaServiceEntity = {
    codigoBaseDatos: "",
    idLogin: "",
    idSede: "",
    fechaInicial: "",
    fechaFinal: "",
    sma: 0
  };

  public arrayObjetoSomaEntity : ObjetoSomaEntity[] = [];
  public showReport: boolean = false;
  public showWarning: boolean = false;
  public showMessage: boolean = true;
  public objetoPermisos: any = {
    imprimir: false,
    descargar: false,
    filtros: false
  };
  public listaObjetoFiltro: ObjetoFiltroSedes[] = [];
  public objetoReporteSoma: any = {
    idSede: "",
    fechaInicial: null,
    fechaFinal: null
  };

  constructor(
    private activatedRoute: ActivatedRoute,
    private servicioSoma: ServicioSomaService,
    private dataPermisos: DataPermisosService,
    private generarText : GenerarTxtSomaService
  ) {
    this.activatedRoute.params.subscribe(params => {
      this.objetoSoma.codigoBaseDatos = params["codigoBaseDatos"];
      this.objetoSoma.idLogin = params["idLogin"];
      this.objetoSoma.sma = params['sma'];

    });

    this.getPermisos();
  }

  public async getPermisos() {
    let ruta: string = await this.activatedRoute.snapshot.url[0].path;
    let result: any = await this.dataPermisos.getPermisos(ruta);

    if (result != null) {
      this.objetoPermisos = result;
    }
  }

  ngOnInit() {
    this.getReponseFilters();
  }

  public async getObjetoReporteSoma(objeto: any) {
    this.objetoReporteSoma = await objeto;
  }

  private async getResponse( objeto : any ) {
    try {
      const response = await this.servicioSoma.getReponse(objeto);
      console.log('Entre');
      if (response != null) {
        response.subscribe((data: any) => {
          if(data) {
            this.showReport = true;
            this.showWarning = false;
            this.arrayObjetoSomaEntity = data;
          } else {
            this.showWarning = true;
          }
        });
      }
    } catch (exception) {
      this.showWarning = false;
      this.showReport = false;
      console.log(exception);
    }
  }

  private async getReponseFilters() {
    try {
      const response = await this.servicioSoma.getResponseFilters(
        this.objetoSoma
      );

      if (response != null) {
        response.subscribe((data: any) => {
          this.listaObjetoFiltro = data;
        });
      }
    } catch (exception) {
      console.log(exception);
    }
  }

  public getGenerar(param: any) {
    
    this.showMessage = false;

    if( this.objetoReporteSoma != null ) {
      this.showReport = false;
      this.showWarning = false;
      this.objetoSoma.idSede = this.objetoReporteSoma.idSede;
      this.objetoSoma.fechaInicial = this.objetoReporteSoma.fechaInicial;
      this.objetoSoma.fechaFinal = this.objetoReporteSoma.fechaFinal;

      this.getResponse(this.objetoSoma);
    } else {
      this.showMessage = true;
    }
  }

  public getDescargar(param:any) {

    if (this.objetoSoma.sma == 3) {
      this.generarText.generarTextByComas(this.arrayObjetoSomaEntity);
    }else{
      this.generarText.generarText(this.arrayObjetoSomaEntity);
    }
  }
}

interface ObjetoFiltroSedes {
  idSede: string;
  descripcion: string;
}
